import type { Job } from '@mairistem/composants';
import { toast } from 'react-toastify';

/**
 * Mandats issus de factures Chorus concernés par une suppression ou une dénumérotation, d'après l'API
 * (bordereau ordinaire de dépense seulement) : message prêt à afficher, null quand aucun ne l'est.
 */
export interface InfoChorus {
	nombreMandatsChorus?: number;
	messageChorus?: string | null;
}

/** Toast d'information quand l'API signale des mandats issus de factures Chorus. */
const afficherInfoChorus = (info?: InfoChorus | null): void => {
	if (info?.messageChorus) {
		toast.info(info.messageChorus);
	}
};

/** Même toast, d'après le résultat JSON d'un Job360 terminé (dénumérotation). */
export const afficherInfoChorusDuJob = (job: Job): void => {
	try {
		afficherInfoChorus(JSON.parse(job.resultat));
	} catch {
		// résultat illisible : rien à signaler
	}
};

export default afficherInfoChorus;
